export const paypalTemplate = {
    exchange: "PayPal",
    fields: [
        { key: "currency", label: "Currency", placeholder: "eg. USD", required: true },
        { key: "amount", label: "Amount (USD)", placeholder: "eg. 500", type: "number", required: true },
        { key: "email", label: "Email (for alerts)", placeholder: "user@example.com", type: "email", required: true },
        { key: "fallbackEmail", label: "Fallback Email", placeholder: "fallback@example.com", type: "email", required: false },
        { key: "senderName", label: "Sender Name", placeholder: "Sender Full Name", required: true },
        { key: "receiverName", label: "Receiver Name", placeholder: "Receiver Full Name", required: true },
    ],
};
